import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EServicesCategoryComponent } from './e-services-category/e-services-category.component';
import { EServicesSubcategoryComponent } from './e-services-subcategory/e-services-subcategory.component';
import { AdministrativeProcedureDetailsComponent } from '../administrative-procedure-details/administrative-procedure-details.component';

const routes: Routes = [
    {
        path: '',
        component: EServicesCategoryComponent
    },
    {
        path: 'eServicesSubcategory/:parentId',
        component: EServicesSubcategoryComponent
    },
    {
        path: 'eServicesSubcategory/:parentId/administrativeProcedureDetails/:Id',
        component: AdministrativeProcedureDetailsComponent
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EServicesRoutingModule { }